import * as Company from './company/';
import * as FileCategory from './file-category';
import * as Score from './score';
export default { Company: Company, Score: Score, FileCategory: FileCategory };



//////////////////
// WEBPACK FOOTER
// ./src/app/common/index.ts
// module id = 1261
// module chunks = 0